export interface MaintenanceTypes {
  maintenance_type: string;
  total: number;
}

export interface CategoryWithTotalCost {
  id: number;
  name: string;
  total_cost: number | null;
}

export interface TotalMaintenanceMaterial {
  device_part: number;
  device_part_name: string;
  total: number;
}

export interface Personals {
  id: number;
  fullname: string;
  total: number;
}

export interface StatisticsResponse {
  total_customer: string;
  total_customer_maintenance: string;
  customer_total_payment: string;
  total_earned: number;
  total_cost: number;
  total_due: string;
  total_device_buy: number;
  total_device_part_buy: number;
  total_device_part_sell: number;
  total_device_sell: number;
  maintenance_types: MaintenanceTypes[];
  categories_with_total_cost: CategoryWithTotalCost[];
  total_maintenance_material: TotalMaintenanceMaterial[];
  total_maintenance_material_repair: TotalMaintenanceMaterial[];
  personals: Personals[];
}

export const formatDate = (dateString: string) => {
  var date = new Date(dateString);

  var year = date.getFullYear();
  var month = (date.getMonth() + 1).toString().padStart(2, "0");
  var day = date.getDate().toString().padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const getDateDaysAgo = (backDay: number) => {
  const today = new Date();

  const sevenDaysAgo = new Date(today);
  sevenDaysAgo.setDate(today.getDate() - backDay);

  const year = sevenDaysAgo.getFullYear();
  const month = String(sevenDaysAgo.getMonth() + 1).padStart(2, "0"); // Ay değeri 0'dan başladığı için +1 eklenir
  const day = String(sevenDaysAgo.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};
